// Icon tones — colour as a *signal*, not decoration.
//
// Owner ruling 2026-08-25: "feel free to add some more colors to the icons, not
// all blue."
//
// The rule that keeps this from becoming a rainbow: a tone is assigned per
// DOMAIN, and the same domain always gets the same hue everywhere it appears —
// nav, stat tiles, empty states, dashboard cards. So an operator learns
// "amber = money, violet = content, emerald = people" once, and colour starts
// carrying meaning instead of just breaking up the grey.
//
// Status colour (success/warning/danger) is NOT here — that lives in
// StatusBadge and must never be reused for domain identity, or a green
// "Content" icon reads as "content is healthy".

export type IconTone =
  | 'brand' // overview / dashboards
  | 'violet' // content + curriculum
  | 'emerald' // people
  | 'amber' // money
  | 'rose' // system / danger-adjacent
  | 'sky' // i18n + languages
  | 'slate'; // neutral, no domain

/** Foreground + soft background, for an icon sitting in a tinted tile. */
export const TONE_TILE: Record<IconTone, string> = {
  brand: 'bg-brand-50 text-brand-600',
  violet: 'bg-violet-50 text-violet-600',
  emerald: 'bg-emerald-50 text-emerald-600',
  amber: 'bg-amber-50 text-amber-600',
  rose: 'bg-rose-50 text-rose-600',
  sky: 'bg-sky-50 text-sky-600',
  slate: 'bg-admin-100 text-admin-500',
};

/** Foreground only, for a bare icon (nav links, inline glyphs). */
export const TONE_TEXT: Record<IconTone, string> = {
  brand: 'text-brand-500',
  violet: 'text-violet-500',
  emerald: 'text-emerald-500',
  amber: 'text-amber-500',
  rose: 'text-rose-500',
  sky: 'text-sky-500',
  slate: 'text-admin-400',
};

/** The domain tone for each nav group heading. */
export const GROUP_TONE: Record<string, IconTone> = {
  Overview: 'brand',
  People: 'emerald',
  Content: 'violet',
  Billing: 'amber',
  System: 'rose',
};
